export default __webpack_public_path__ + "440b13efb83e6e4ac0c569339053a4c7.png";